import React from 'react';

import AirtelMap from '../AirtelMap';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import MapControls from '../MapControls/MapControls';
import MarkerCluster from '../MarkerCluster/MarkerCluster';
import MapLegend from '../MapLegend/MapLegend';
import MapTooltip from '../MapTooltip/MapTooltip';

import apiKey from '../constants';

import mapStyles from '../Styles/addressStyles.json';

class AddressMap extends AirtelMap {
  static defaultProps = {
    marker: {
      name: 'Current location',
      title: 'Airtel marker'
    },
    clusters: [],
    styles: mapStyles,
    zoom: 18,
    minZoom: 3
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (nextProps.center !== prevState.initialCenter) {
      return {
        initialCenter: nextProps.center,
        marker: nextProps.marker
      };
    }

    return null;
  }

  render() {
    const {
      initialCenter,
      currentCenter,
      satellite,
      marker
    } = this.state;

    const { lat, lng } = this.state.marker.position;

    const {
      zoom,
      google,
      withLegend,
      styles,
      clusters,
      lockedMarker,
      tooltipContent,
      ...rest
    } = this.props;

    return (
      <Map
        center={currentCenter}
        disableDefaultUI
        initialCenter={initialCenter}
        google={google}
        styles={styles}
        onDragend={this.centerMoved}
        zoom={zoom}
        ref={this.mapRef}
        onClick={this.handleMapClicked}
        scrollwheel={false}
        {...rest}
      >
        {
          marker &&
            <Marker
              onClick={this.handleMarkerClicked}
              onMousedown={!lockedMarker && this.handleMarkerDragStart}
              draggable={!lockedMarker}
              onDragend={this.handleMarkerDragend}
              title={marker.title}
              name={marker.name}
              position={marker.position}
              icon={{
                url: satellite
                  ? '/assets/airtelMarkerPhotographic.svg'
                  : '/assets/airtelMarker.svg',
                anchor: new google.maps.Point(31,57),
                scaledSize: new google.maps.Size(60,60)
              }}
            />
        }
        {
          clusters.map((cluster, i) => (
              <MarkerCluster
                title={cluster.title}
                label={cluster.label}
                position={cluster.position}
                key={`cluster-${i}`}
              />
            )
          )
        }
        {
          withLegend &&
            <MapLegend icon={{ name: 'pop', type: '20' }} />
        }
        <MapControls
          satellite={satellite}
          clickCenter={this.handleClickCenter}
          clickZoomIn={this.handleClickZoomIn}
          clickZoomOut={this.handleClickZoomOut}
          clickMapType={this.handleClickMapType}
        />

        <MapTooltip
          infoWindowRef={this.infoWindowRef}
          marker={this.state.activeMarker}
          visible={this.state.showingInfoWindow}
        >
          {tooltipContent && tooltipContent(lat, lng)}
        </MapTooltip>
      </Map>
    );
  }
}

export default GoogleApiWrapper({ apiKey })(AddressMap);



// WEBPACK FOOTER //
// ./src/uis/components/Map/AddressMap/AddressMap.js